export class Formatter {
	static formatMoney(value: number | bigint): string {
		if (value === 0) return "Miễn phí"
		return new Intl.NumberFormat("vi-VN", {
			currency: "VND",
			style: "currency",
		}).format(value)
	}

	static formatDecimal(value: number | bigint): string {
		return new Intl.NumberFormat("vi-VN", {
			style: "decimal",
		}).format(value)
	}
	static isNull(value: string | undefined): boolean {
		return value === null || value === undefined || value === ""
	}
}
